const sectionIds = {
  PERSONAL_INFO: 'personalInfo',
  ACCOUNT_INFO: 'accountInfo',
  EMAIL_SUBSCRIPTIONS_INFO: 'emailSubscriptionsInfo',
  CHANGE_PASSWORD: 'changePassword',
  ACCOUNT_CHANGES_INFO: 'accountChangesInfo',
};

export default sectionIds;
